import React from 'react';
import { Text } from '@chakra-ui/react';
import TextHighlighter from '@/utils/react/TextHighLighter';

export type HighlightedTextProps = {
  value: string;
  match: string;
};

export const HighlightedText = ({ value, match }: HighlightedTextProps) => (
  <Text textStyle="body3" display="flex" flexDirection="row" whiteSpace="pre-wrap">
    <TextHighlighter
      value={value}
      match={match.trim()}
      formatter={(matched) => (
        <Text as="strong" textStyle="body3" fontWeight="bold">
          {matched}
        </Text>
      )}
    />
  </Text>
);
